<template lang="pug">
.content-center
  .pagepanel
    .page-group
      .item-group.mb-2
        ul.p-0.m-0
          li.item-single.d-flex.px-3
            .value.w-50 {{ $t("ui.account_id") }}
            .detail.w-50.grey {{ account_id }}
          template(v-if="!whiteLabel")
            li.item-single.d-flex.px-3(v-if="nickname != null")
              .value.w-50 {{ $t("ui.nickname") }}
              .detail.w-50.grey {{ nickname }}
            li.item-single.d-flex.px-3(v-else data-toggle="modal" data-target="#nickname")
              .value.w-50 {{ $t("ui.nickname") }}
              .detail.w-50.grey
                i.fas.fa-pen
            li.item-single.d-flex.px-3(data-toggle="modal" data-target="#password")
              .value.w-50 {{ $t("ui.password") }}
              .detail.w-50.editable **********
          li.item-single.d-flex.px-3(data-toggle="modal" data-target="#changeLang")
            .value.w-50 {{ $t("ui.language") }}
            .detail.w-50.editable {{ $t("language." + language) }}
      .item-group.mb-2
        ul.p-0.m-0
          li.item-single.d-flex.px-3(data-toggle="modal" data-target="#oddsType")
            .value.w-50 {{ $t("ui.odds_type") }}
            .detail.w-50 {{ $tc(oddsTypeList[pageDisplay.oddsType], 2) }}
      .item-group.mb-2
        ul.p-0.m-0
          li.item-single.d-flex.px-3(@click="go('/customize_sports_order')")
            .value.w-50 {{ $t("ui.customize_sports_order") }}
            .detail.w-50.grey
              i.fas.fa-chevron-right
          //- li.item-single.d-flex.px-3(data-toggle="modal" data-target="#homePreferences")
          //-   .value.w-50 {{ $t("ui.home_preferences") }}
          //-   .detail.w-50.editable Home
      //- .item-group.mb-2
      //-   ul.p-0.m-0
      //-     li.item-single.d-flex.px-3(data-toggle="modal" data-target="#defaultStake")
      //-       .value.w-50 {{ $t("ui.default_stake") }}
      //-       .detail.w-50.editable {{ $t(stakes[betting.defaultStake - 1]) }}
      //-     li.item-single.d-flex.px-3
      //-       .value.w-50 {{ $t("ui.accept_better_odds") }}
      //-       .detail.w-50.check-select
      //-         label.remember
      //-           input(type="checkbox" :checked="betting.acceptBetterOdds == 'true'" @click="toggleAcceptBetterOdds()")
      //-           span.checkmark
      //- .item-group.mb-2
      //-   ul.p-0.m-0
      //-     li.item-single.d-flex.px-3
      //-       .value.w-50 {{ $t("ui.quick_bet") }}
      //-       .detail.w-50.check-select
      //-         label.remember
      //-           input(type="checkbox" :checked="betting.quickBet == 'true'" @click="toggleQuickBet()")
      //-           span.checkmark
      .item-group.mb-2
        ul.p-0.m-0
          li.item-single.d-flex.px-3
            .value.w-50 {{ $t("ui.auto_refresh_odds") }}
            .detail.w-50.check-select
              label.remember
                input(type="checkbox" :checked="betting.autoRefreshOdds == 'true'" @click="toggleAutoRefreshOdds()")
                span.checkmark
          li.item-single.d-flex.px-3(data-toggle="modal" data-target="#eventsSorting")
            .value.w-50 {{ $t("ui.default_event_sorting") }}
            .detail.w-50.editable {{ $t(eventSorting[pageDisplay.eventSorting - 1]) }}
          li.item-single.d-flex.px-3
            .value.w-50 {{ $t("ui.accept_any_odds") }}
            .detail.w-50.check-select
              label.remember
                input(type="checkbox" :checked="betting.acceptAnyOdds == 'true'" @click="toggleAcceptAnyOdds()")
                span.checkmark
</template>

<script>
import { EventBus } from "@/library/_event-bus.js";
import config from "@/config";

export default {
  data: () => ({
    betting: {
      defaultStake: "0",
      acceptBetterOdds: "true",
      acceptAnyOdds: "false",
      autoRefreshOdds: "true",
      quickBet: "false",
      defaultStakeAmount: "1"
    },
    pageDisplay: {
      language: "en",
      oddsType: config.defaultOdds,
      pageType: "2",
      showScoreMap: "false",
      eventSorting: "1",
      marketType: "1",
      pageSize: "10"
    },
    stakes: ["ui.last_bet", "ui.customize", "ui.disable"],
    oddsTypeList: {
      "MY":"ui.my_odds",
      "HK":"ui.hk_odds",
      "ID":"ui.id_odds",
      "DEC":"ui.dec_odds"
    },
    eventSorting: ["ui.normal_sorting", "ui.sort_by_time"]
  }),
  computed: {
    whiteLabel() {
      return config.whiteLabel == "1";
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    displayName() {
      return this.account_id;
    },
    account_id() {
      return this.$store.getters.accountId;
    },
    nickname() {
      return this.$store.getters.nickName;
    },
    language() {
      return this.$store.getters.language;
    },
  },
  destroyed() {
    EventBus.$off("DEFAULT_STAKE", this.busStake);
    EventBus.$off("ODDS_TYPE", this.busOdds);
    EventBus.$off("DEFAULT_EVENT_SORTING", this.busEventSort);
  },
  mounted() {
    this.initialize();
    EventBus.$on("DEFAULT_STAKE", this.busStake);
    EventBus.$on("ODDS_TYPE", this.busOdds);
    EventBus.$on("DEFAULT_EVENT_SORTING", this.busEventSort);
  },
  methods: {
    busStake() {
      this.betting.defaultStake = this.$store.getters.betting.defaultStake;
      this.betting.defaultStakeAmount = this.$store.getters.betting.defaultStakeAmount;
    },
    busOdds() {
      this.pageDisplay.oddsType = this.$store.getters.pageDisplay.oddsType;
    },
    busEventSort() {
      this.pageDisplay.eventSorting = this.$store.getters.pageDisplay.eventSorting;
    },
    go(e) {
      this.$router.push(e);
    },
    initialize() {
      this.betting.defaultStake = this.$store.getters.betting.defaultStake;
      this.betting.acceptBetterOdds = this.$store.getters.betting.acceptBetterOdds;
      this.betting.acceptAnyOdds = this.$store.getters.betting.acceptAnyOdds;
      this.betting.autoRefreshOdds = this.$store.getters.betting.autoRefreshOdds;
      this.betting.quickBet = this.$store.getters.betting.quickBet;

      this.pageDisplay.language = this.$store.getters.language;
      this.pageDisplay.oddsType = this.$store.getters.pageDisplay.oddsType;
      this.pageDisplay.pageType = this.$store.getters.pageDisplay.pageType;
      this.pageDisplay.showScoreMap = this.$store.getters.pageDisplay.showScoreMap;
      this.pageDisplay.eventSorting = this.$store.getters.pageDisplay.eventSorting;
      this.pageDisplay.marketType = this.$store.getters.pageDisplay.marketType;
      this.pageDisplay.pageSize = this.$store.getters.pageDisplay.pageSize;
    },
    toggleAutoRefreshOdds() {
      this.$store.dispatch("layout/setSingleBetting", {property: "autoRefreshOdds", value: this.betting.autoRefreshOdds == "true" ? "false" : "true"});
      this.betting.autoRefreshOdds = !this.betting.autoRefreshOdds;
    },
    toggleAcceptBetterOdds() {
      this.$store.dispatch("layout/setSingleBetting", {property: "acceptBetterOdds", value: this.betting.acceptBetterOdds == "true" ? "false" : "true"});
      this.betting.acceptBetterOdds = !this.betting.acceptBetterOdds;
    },
    toggleAcceptAnyOdds() {
      this.$store.dispatch("layout/setSingleBetting", {property: "acceptAnyOdds", value: this.betting.acceptAnyOdds == "true" ? "false" : "true"});
      this.betting.acceptAnyOdds = !this.betting.acceptAnyOdds;
    },
    toggleQuickBet() {
      this.$store.dispatch("layout/setSingleBetting", {property: "quickBet", value: this.betting.quickBet == "true" ? "false" : "true"});
      this.betting.quickBet = !this.betting.quickBet;
    }
  }
};
</script>